// removed by extract-text-webpack-plugin
module.exports = {"headerToolbarWrapper":"style__headerToolbarWrapper___2_GZV","logo":"style__logo___3Paw9"};


//////////////////
// WEBPACK FOOTER
// ./components/Header/style.scss
// module id = ./components/Header/style.scss
// module chunks = 5